/** A slider used inside a strip that allows horizontal scrolling over the content */
import React from 'react';
import Slider from '@wix/da-shared-react/pkg/Slider';
import { DeviationTypes } from '@wix/da-shared-react/pkg/types/deviation';
import { PapiNetworkbarStrip } from '@wix/da-types-papi';
import {
  getStripType,
  getItemId,
  getStripItems,
  getStripDeviationType,
} from '../../helpers/streams';
import StripItem from './StripItem';

import s from './StripSlider.scss';

const DEFAULT_STRIP_ITEM_SIZE = {
  width: 205,
  height: 177,
};

const COMMISSION_STRIP_ITEM_SIZE = {
  width: 330,
  height: 284 + 82,
};

export interface Props {
  /** stream data and initial array of content and url pointing to larger collection */
  strip: PapiNetworkbarStrip;
  disableShowLess?: boolean;
  /** root class (ONLY on the search page) */
  className?: string;
  /** inner row of content class (ONLY on the search page) */
  contentClassName?: string;
}

export const StripSlider: React.FC<Props> = ({ strip, disableShowLess }) => {
  const type = getStripType(strip);
  const items = getStripItems(strip);

  const elementSize =
    getStripDeviationType(strip) === DeviationTypes.COMMISSION
      ? COMMISSION_STRIP_ITEM_SIZE
      : DEFAULT_STRIP_ITEM_SIZE;

  if (!items) {
    return null;
  }

  return (
    <Slider className={s['root']} scrollBy={elementSize.width * 4} permArrows>
      {items.map((item, index) => (
        <StripItem
          itemIndex={index}
          key={`strip-${type}-${getItemId(item)}`}
          type={type!}
          item={item}
          elementSize={elementSize}
          disableShowLess={disableShowLess}
        />
      ))}
    </Slider>
  );
};
StripSlider.displayName = 'StripSlider';

export default StripSlider;
